<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <registrations-clear></registrations-clear>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RegistrationsClear from './registrations/RegistrationsClear';

    export default {

        components: {
            RegistrationsClear
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.registrations'),
                        route: '/astral/ui/training/registrations'
                    },
                    {
                        name: this.$t('common.outdated'),
                    },
                ]
            }
        },
    }
</script>
